import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  idSelectedCandidate?: string;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  idSelectedCandidate: undefined,
  data: {},
};

const evaluateCVSlice = createSlice({
  name: "evaluateCV",
  initialState,
  reducers: {
    evaluateCVStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    evaluateCVSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    evaluateCVFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetEvaluateCV: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = {};
      state.idSelectedCandidate = undefined;
    },
  },
});

export const {
  evaluateCVStart,
  evaluateCVSuccess,
  evaluateCVFailed,
  resetEvaluateCV,
} = evaluateCVSlice.actions;

export default evaluateCVSlice.reducer;
